export function printPdfFile(buffer) {
	const blob = new Blob([buffer], { type: 'application/pdf' });
	const urlBlob = URL.createObjectURL(blob);

	const previousIframe = document.querySelector('print-pdf-iframe');
	if (previousIframe) {
		URL.revokeObjectURL(previousIframe.src);
		previousIframe.remove();
	}

	const iframe = document.createElement('iframe');
	iframe.classList.add('print-pdf-iframe');
	iframe.style.display = 'none';
	iframe.src = urlBlob;
	document.body.appendChild(iframe);
	iframe.addEventListener('load', () => {
		iframe.contentWindow.print();
	});
}
